import { createFilterActionResolver } from '#layers/filters/components/Filter/utils/filter-action';
import { injectFilterSchemaContext } from '#layers/filters/components/Filter/utils/filter-schema-context';
import { useFilterConfigResolver } from '#layers/filters/components/Filter/utils/use-filter-config-resolver';
import { useFilterGate } from './use-filter-gate';

/** Pickers and insertion handlers share the same clause construction and gate checks. */
export function useFilterActions() {
	const schema = injectFilterSchemaContext();
	const config = useFilterConfigResolver();
	const gate = useFilterGate();
	return createFilterActionResolver({ ...schema, ...config, allowsClause: gate.allowsClause });
}
